import Lara from "@/presets/lara";

export const pagePresets = {
  ...Lara,
  accordion: {
    // ...Lara.accordiontab,
    root: {
      class: ["mb-1", "border-solid", "border-b", "border-slate-200"],
    },
    accordiontab: {
      header: ({ props }) => ({
        class: [
          // State
          {
            "select-none pointer-events-none cursor-default opacity-60": props?.disabled,
          },

          "my-3",

          //Font
          "font-montserrat",
          "text-normal",
          "!font-semibold",
          "text-university-primary",
          "capitalize",
        ],
      }),
      headerAction: ({ context }) => ({
        class: [
          //Font
          "leading-none",

          // Alignments
          "flex flex-row-reverse items-center justify-between",
          "relative",

          // Color
          "text-surface-600 dark:text-surface-0/80",
          { "text-surface-900": context.active },

          // Transition
          "transition duration-200 ease-in-out",
          "transition-shadow duration-200",

          // States

          "hover:text-surface-900",
          "focus:outline-none focus:outline-offset-0 focus-visible:ring focus-visible:ring-primary-400/50 ring-inset dark:focus-visible:ring-primary-300/50", // Focus

          // Misc
          "cursor-pointer no-underline select-none",
        ],
      }),
      headerIcon: {
        class: "inline-block m-1",
      },
      headerTitle: {
        class: "",
      },
      content: {
        class: [
          // Spacing
          "flex-col justify-between",
        ],
      },
      toggleableContent: {
        class: [],
      },
      transition: {
        enterFromClass: "max-h-0",
        enterActiveClass: "overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)]",
        enterToClass: "max-h-[1000px]",
        leaveFromClass: "max-h-[1000px]",
        leaveActiveClass: "overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)]",
        leaveToClass: "max-h-0",
      },
    },
  },
};
